import { ColorModeScript, useColorModeValue } from "@chakra-ui/color-mode";
import { Box } from "@chakra-ui/layout";
import { graphql, useStaticQuery } from "gatsby";
import React, { useMemo } from "react";
import SearchContextProvider from "../context/SearchContext";
import theme from "../../theme";

const normalizeSearch = (str = "") => {
  return str
    .toLocaleLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

function Layout({ children }) {
  const data = useStaticQuery(graphql`
    {
      momazos: allAirtable(
        filter: { table: { eq: "Memes" }, data: { Status: { eq: "Active" } } }
        sort: { fields: data___Created, order: DESC }
      ) {
        totalCount
        edges {
          node {
            id
            data {
              Name
              tags
              Attachments {
                localFiles {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      formats: [AUTO, AVIF, WEBP]
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const serializeSearch = useMemo(
    () =>
      data.momazos.edges.map(({ node }) => ({
        id: node.id,
        name: node.data.Name,
        image: node.data.Attachments,
        tags: node.data.tags,
        plainText: normalizeSearch(node.data.Name),
      })),
    [data]
  );

  const bg = useColorModeValue("white", "gray.800");
  const color = useColorModeValue("gray.700", "white");

  return (
    <Box bg={bg} color={color}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <SearchContextProvider data={serializeSearch}>
        {children}
      </SearchContextProvider>
    </Box>
  );
}

export default Layout;
